import { render, staticRenderFns } from "./Setting-Password.vue?vue&type=template&id=8909e854&"
import script from "./Setting-Password.vue?vue&type=script&lang=js&"
export * from "./Setting-Password.vue?vue&type=script&lang=js&"
import style0 from "./Setting-Password.vue?vue&type=style&index=0&id=8909e854&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports